module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Active"
    },
    model: {
      value: (_vm.roleActive),
      callback: function($$v) {
        _vm.roleActive = $$v
      },
      expression: "roleActive"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Role Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name",
      "required": "",
      "rules": _vm.nameRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.roleName),
      callback: function($$v) {
        _vm.roleName = $$v
      },
      expression: "roleName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Role Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description",
      "required": "",
      "rules": _vm.descriptionRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.roleDescription),
      callback: function($$v) {
        _vm.roleDescription = $$v
      },
      expression: "roleDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Role User Type:")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.userType,
      "label": "User Type",
      "required": "",
      "rules": _vm.userRules,
      "item-value": "id",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.roleUserType),
      callback: function($$v) {
        _vm.roleUserType = $$v
      },
      expression: "roleUserType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleUserType == '1'),
      expression: "roleUserType == '1'"
    }],
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Is Role Commercial Role:")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.roleCommercialKam),
      callback: function($$v) {
        _vm.roleCommercialKam = $$v
      },
      expression: "roleCommercialKam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddRole()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}